import React from 'react'

import { cleanString } from 'utils/utils'

import * as S from './style'

const BreadCrumb = ({ breadCrumb = [] }) => {
  const items = Object.keys(breadCrumb).map(key => ({
    name: breadCrumb[key].Key,
    url: breadCrumb[key].Description,
  }))
  return (
    !!items.length && (
      <S.Container itemScope itemType="https://schema.org/BreadcrumbList">
        {items.map(({ name, url }, index) => (
          <S.List
            key={index}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <a itemProp="item" href={url}>
              <span itemProp="name">
                {cleanString(name, {
                  toLowerCase: 1,
                  capitalizeAll: 1,
                })}
              </span>
            </a>
            <meta itemProp="position" content={index + 1} />
          </S.List>
        ))}
      </S.Container>
    )
  )
}

export default BreadCrumb
